import BigTemplate from '../BigTemplate.js'
import VideoTemplateLegacy from "../VideoTemplateLegacy";
import {
    appendSubPlayTemplateView,
    customCommand,
    VideoBridgeInit,
    VideoBridgeReadyStatusHasReady,
    VideoBridgeReadyStatusNotReady,
    VideoBridgeReportUrls
} from "../../../api";
import {
    callDeveloperClicked,
    callDeveloperDismissed,
    callDeveloperEndCardShowSuccess,
    callDeveloperPlayCompleted,
    callDeveloperShowFailed,
    callDeveloperShowSucccess
} from "../../../api/noticeDeveloperAPI";
import {
    onSubPlayTemplateViewCloseBtnClicked,
    onSubPlayTemplateViewLoad,
    onComponentReactDeveloperCallbackCLICKED,
    onComponentReactDeveloperCallbackDISMISSED,
    onComponentReactDeveloperCallbackENDCARDSHOWSUCCESS,
    onComponentReactDeveloperCallbackPLAYCOMPLETED,
    onComponentReactDeveloperCallbackPLAYFAILED,
    onComponentReactDeveloperCallbackPLAYSUCCESS
} from "../../../api/componentReactListener";
import {_getUrlParams} from "../../../common/m_base/util";

/**
 * mintegral SDK 大模板
 */
export default class BigTemplateDefault extends BigTemplate {

    constructor(...props) {
        super(...props)

        // 表明当前模板如果要成功加载, 至少需要多少个 campaign
        this.expectCampaignNumber = 2
        // 用来存储当前用户选择的, 将要进行播放的子模板
        this.currentChildTpl = null
        // 存储通过当前大模板创建的子模板索引列表
        this.childTplList = []

        this.tplList = []
        this.campaignList = null
        this.unitSetting = null
        this.unitId = null
        this.dataSource = null
    }

    async init({JsBridgeRes}) {
        super.init({JsBridgeRes})

        // 从 SDK 获取 campaign 列表, 和当前环境的上下文信息
        await this.fetchSDKContext()

        // 如果当前从 SDK 获取到的 campaign 数量满足模板渲染要求
        if (this.campaignList && this.campaignList.length === this.expectCampaignNumber) {

            // VideoBridgeReadyStatusHasReady()

            // 渲染大模板静态 UI
            this.renderPageStaticUI()

            this.videoTemplateLegacy = new VideoTemplateLegacy({
                unitId: this.unit_id,
                unitSetting: this.unitSetting,
                sdkSetting: this.sdkSetting,
            })

            // 批量创建并预加载 "播放模板" 视图 (Native)
            await this.batchCreateVideoTemplateLegacy()

            // 两个 type 模板实例创建成功之后, 批量添加模板 preload 的事件监听
            this.addPreloadFinishEventListener()

            // preload URL
            await this.batchPreloadVideoTemplateLegacy()

        } else {
            console.warn('当前 campaign 不满足模板初始化条件, 请检查.', {campaignList: this.campaignList})
            this.localLog('当前 campaign 不满足模板初始化条件, 请检查: ', {campaignList: this.campaignList})
            VideoBridgeReadyStatusNotReady({
                errMessage: '当前 campaign 不满足模板初始化条件, 请检查',
                errDetail: this.campaignList && JSON.stringify({length: this.campaignList.length})
            })
        }

        this.initComponents()
    }

    /**
     * 获取并初始化 SDK 的上下文
     * @returns {Promise<boolean|{appSetting: *, bigTemplateInstanceId: *, campaignList: *, sdkSetting: *, unitSetting: *, sdk_info: *, unit_id: *, device: *}>}
     */
    async fetchSDKContext() {
        const VideoBridgeRes = await VideoBridgeInit().catch(error => console.warn(error))
        console.log({VideoBridgeRes})

        if (typeof VideoBridgeRes === 'undefined') {
            console.warn('VideoBridge init 获取 SDK 上下文失败, VideoBridgeRes: ', VideoBridgeRes)
            return false
        }

        const {campaignList, sdk_info, unit_id, appSetting, unitSetting, sdkSetting, device} = VideoBridgeRes

        // 获取大模板的 cmptId
        const bigTemplateInstanceId = sdkSetting && sdkSetting.instanceId

        // 构建 "全局" 的上下文环境对象
        let MTG_SDKContext = {
            campaignList,
            sdk_info,
            unit_id,
            appSetting,
            unitSetting,
            sdkSetting,
            device,
            bigTemplateInstanceId
        }
        window.MTG_SDKContext = MTG_SDKContext

        // 将数据填充到 "当前实例" 的上下文中
        this.campaignList = campaignList
        this.sdk_info = sdk_info
        this.unit_id = unit_id
        this.appSetting = appSetting
        this.unitSetting = unitSetting
        this.sdkSetting = sdkSetting
        this.device = device
        this.bigTemplateInstanceId = bigTemplateInstanceId

        return MTG_SDKContext
    }

    /**
     * 渲染大模板的静态 UI 部分
     */
    renderPageStaticUI() {
        let dataForRender = {
            campaignList: this.formatCampaign(this.campaignList)
        };
        window.MTG_RENDER(dataForRender)
        this.hidePageLoading()
    }

    /**
     * 批量创建 type4 模板实例
     * @returns {Promise<void>}
     */
    async batchCreateVideoTemplateLegacy() {
        for (let campaign of this.campaignList) {
            console.log('jsBridge._callNative({fnName: \'operateComponent\', params})')
            let createRes = await this.videoTemplateLegacy
                .create({campaign})
                .catch(err => {
                    console.warn('创建 Native 播放模板异常: ', {err})
                    this.localLog('--- 创建 Native 播放模板异常: ', {err});
                    VideoBridgeReadyStatusNotReady({
                        errMessage: '创建 Native 播放模板异常',
                        errDetail: JSON.stringify(err || {})
                    })
                })

            if (this.checkCreateResOK(createRes)) {
                console.warn('创建 Native 播放模板成功: ', {createRes})
                this.localLog('--- 创建 Native 播放模板成功: ', {createRes})
                // 关联 campaign 和 原生组件
                this.childTplList.push({
                    campaignId: campaign.id,
                    tplInstanceId: createRes.data.id,
                    isPageLoadFinished: false,
                })
                console.log('childTplList: ', this.childTplList)
            } else {
                console.warn('创建 Native 播放模板失败: ', {createRes})
            }

        }
    }

    addPreloadFinishEventListener() {
        for (let curTplItem of this.childTplList) {
            let expectCmptId = curTplItem && curTplItem.tplInstanceId
            this.localLog('批量添加模板 preload finish 的事件监听, 当前添加的模板: ', curTplItem)
            // preload finish 回调 401
            onSubPlayTemplateViewLoad({
                expectCmptId,
                cb: ({id, data} = {}) => {

                    if (data && data.result !== 1) {
                        console.warn('当前模板加载失败(2)或超时(3): ', {id, data})
                        return false
                    }

                    curTplItem.isPageLoadFinished = true
                    console.warn('=-= -------------------- preload 成功, 当前 load 成功的模板实例为: ', {id, data})
                    console.log('=-= 当前所有模板的 load 状态: ', this.childTplList)

                    // 给当前模板添加 2345 开发者回调事件监听
                    console.log('---------- bu注册开发者回调监听 start ----------')
                    // 在大模板中预先初始化开发者回调所需的 Handler
                    this.registerDeveloperCallbackHandler({expectCmptId})
                    console.log('---------- bu注册开发者回调监听 end ----------')

                    // 给当前模板添加关闭按钮回调
                    console.log('---------- 注册用户点击关闭按钮监听 start ----------')
                    this.registerEndCardCloseButtonHandler({expectCmptId});
                    console.log('---------- 注册用户点击关闭按钮监听 end ----------')

                    // 判断如果所有模板都 preload 成功, 则执行下一步 (addSubView/回调 SDK ready)
                    if (this.allTplPreloadFinished()) {

                        console.warn('------------------------------ =-= 所有模板 preload 成功 ------------------------------')
                        sessionStorage.setItem(Date.now(), '------------------------------ =-= 所有模板 preload 成功 ------------------------------')

                        console.log('---------- 注册用户交互事件监听 start ----------')
                        // 在大模板中预先初始化用户交互事件所需的 Handler
                        this.registerPageHandler()
                        console.log('---------- 注册用户交互事件监听 end ----------')

                        console.log('---------- 上报 HasReady start ----------')
                        // 检查所有模板是否都已经 preload finished, 如果是则通知 SDK ready
                        VideoBridgeReadyStatusHasReady()
                        console.log('---------- 上报 HasReady end ----------')

                    } else {
                        this.localLog('已经加载成功了一个模板, 但还有 1 个模板正在加载中...', curTplItem)
                        console.log('已经加载成功了一个模板, 但还有 1 个模板正在加载中...', this.childTplList)
                    }
                }
            })
        }
    }

    async batchPreloadVideoTemplateLegacy() {
        for (let curTplItem of this.childTplList) {
            if (!curTplItem.isPageLoadFinished) {
                console.log(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 调用开始: ', {curTplIndex: curTplItem})
                let preloadRes = await this.videoTemplateLegacy
                    .preload({id: curTplItem && curTplItem.tplInstanceId})
                    .catch(err => {
                        console.warn(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 异常', {err})
                        this.localLog('preload 异常: ', {curTplItem, err})
                        VideoBridgeReadyStatusNotReady({
                            errMessage: 'preload 异常',
                            errDetail: JSON.stringify({curTplItem, err})
                        })
                    })
                if (preloadRes && preloadRes.code === 0) {
                    console.log(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 调用成功----------', {
                        preloadRes,
                        curTplItem
                    })
                } else {
                    console.warn(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 失败', {
                        preloadRes,
                        curTplItem
                    })
                    this.localLog('preload 失败: ', {curTplItem, preloadRes})
                    VideoBridgeReadyStatusNotReady({
                        errMessage: 'preload 失败',
                        errDetail: JSON.stringify({curTplItem, preloadRes})
                    })
                }
            }
        }
    }

    /**
     * 将关键节点 log 存储在 localStorage 中, 方便 iOS 调试
     * @param text
     * @param err
     */
    localLog(text, err) {
        localStorage.setItem(String(Date.now()) + String(Math.random()), `${text}', ${JSON.stringify(err)}`)
    }

    /**
     * 监听 type4 广告 endcard 阶段, triggerCloseBtn 被触发时 SDK 发出的事件通知
     * 接到通知时, 由 H5 调用 SDK API 通知开发者 dismissed 回调, 之后无论回调成功失败超时, 都需要调用 API 关闭当前广告
     */
    registerEndCardCloseButtonHandler({videoTemplateLegacy, expectCmptId}) {
        // 1. componentReact 402
        console.warn('|||||||||| 1. start - 注册用户点击关闭按钮监听: componentReact 402')
        onSubPlayTemplateViewCloseBtnClicked({
            expectCmptId,
            cb: async ({id, data}) => {

                // 2. reactDeveloper type 6
                console.warn('|||||||||| 2. start - "用户点击关闭按钮事件" 被触发, 即将调用开发者 dismissed 回调: reactDeveloper type 6')
                // type 4 类型广告被关闭, 调用 SDK API 通知开发者 dismissed 回调: data.convert // 1/2(成功/失败)
                let developerCallbackResult = await callDeveloperDismissed({
                    unitId: this.unitId,
                    data
                })
                console.warn('|||||||||| 2. end - 调用开发者 dismissed 回调完成', {developerCallbackResult})

                // 3. operate 402
                console.warn('|||||||||| 3. start - 即将调用最终的 close : operate 402')
                let closeResult = await this.videoTemplateLegacy.close({id})
                console.warn('|||||||||| 3. end - 调用最终的 close 完成: operate 402')
            }
        })
        console.warn('|||||||||| 1. end - 注册用户点击关闭按钮监听: componentReact 402')
    }

    /**
     * 在收到特定 SDK 事件时通知 SDK 给开发者展示广告阶段的回调
     * 当前支持的开发者回调 type:
     *      1: showsuccess， // 开发者调用 show 成功
     *      2: showfailed (error)， // 开发者调用 show 失败
     *      3: playcompleted， // 视频播放完毕
     *      4: endcardshowsuccess， // endcard 成功展示
     *      5: clicked， // 通过点击 cta button 或其他方式触发的 install 时触发
     *      6: dismissed（boolean convert） // endcard 被关闭
     */
    registerDeveloperCallbackHandler({expectCmptId}) {
        console.warn('--------------- 在收到特定 SDK 事件时通知 SDK 给开发者展示广告阶段的回调')

        let unitId = this.unit_id

        onComponentReactDeveloperCallbackPLAYSUCCESS({
            expectCmptId,
            cb: ({id, data}) => {
                console.warn('onComponentReactDeveloperCallbackPLAYSUCCESS')
                // 注意: SDK 针对 "type 4 类型" 的原生视图了特殊定制,
                //  与老版本的 RewardVideo 在开发者回调方面有以下区别:
                //  1. 老版本的 RewardVideo 会在视频开始播放时同时上报 only_impression_url 和 impression_url (即 PV), 且会主动发 showsuccess
                //  2. 新版本 SDK 大模板流程中的 "type 4 类型" 在视图被展示且自动开始播放时只会上报 impression_url, 且不会主动发 showsuccess
                //  因为按照二选一模板的逻辑, showsuccess 开发者回调在大模板的 webviewshow 阶段就需要调用了,
                //  这里需要无视 SDK 发出的 showsuccess, 二选一模板在收到此类型 componentReact 时不作处理即可
                // // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
                // callDeveloperShowSucccess({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackPLAYFAILED({
            expectCmptId,
            cb: ({id, data}) => {
                // 大模板展示失败时, 调用 SDK API 通知开发者 showerror 回调
                callDeveloperShowFailed({unitId, data}) /* data: {error: data.error} */
            }
        })

        onComponentReactDeveloperCallbackPLAYCOMPLETED({
            expectCmptId,
            cb: ({id, data}) => {
                // "type 4 类型" 广告播放完成时, 调用 SDK API 通知开发者 playcompleted 回调
                callDeveloperPlayCompleted({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackENDCARDSHOWSUCCESS({
            expectCmptId,
            cb: ({id, data}) => {
                // endcard 展示成功时, 调用 SDK API 通知开发者 endcardshowsuccess 回调
                callDeveloperEndCardShowSuccess({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackCLICKED({
            expectCmptId,
            cb: ({id, data}) => {
                // clicked 时, 调用 SDK API 通知开发者 clicked 回调
                callDeveloperClicked({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackDISMISSED({
            expectCmptId,
            cb: ({id, data}) => {
                // // type 4 类型广告被关闭, 调用 SDK API 通知开发者 dismissed 回调: data.convert // 1/2(成功/失败)
                // 二选一模板的关闭不再需要监听 SDK 发出的 "开发者回调事件", 而是在用户点击 endcard 阶段的关闭按钮时,
                //  直接调用开发者回调 "dismissed", 并在 SDK 返回成功时, 直接调用 Native 关闭方法 (operateComponent 402)
                // callDeveloperDismissed({unitId, data})
            }
        })
    }

    /**
     * 检查 SDK 返回的创建结果是否 ok
     * @param createRes
     * @returns {*|boolean}
     */
    checkCreateResOK(createRes) {
        return createRes && createRes.code === 0 && createRes.data && createRes.data.id;
    }

    /**
     * 隐藏全屏 loading 提示
     */
    hidePageLoading() {
        let DOMLoading = document.querySelector('.page-loading');
        if (DOMLoading && DOMLoading.style) DOMLoading.style.display = 'none'
    }

    /**
     * SDK fireEvent webviewshow 时应该调用的逻辑
     */
    show() {
        super.show()

        // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
        console.warn('=====', '大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调')
        callDeveloperShowSucccess({
            unitId: this.unit_id,
            data: {}
        })

        // 大模板被展示, 上报通知 SDK 上报 only impression
        this.reportOnlyImpression()
    }

    // 大模板被展示, 上报通知 SDK 上报 only impression
    reportOnlyImpression() {
        let campaign = this.campaignList && this.campaignList[0]
        let urlsWillReport = [{
            type: campaign && campaign.imp_ua,
            url: campaign && campaign.only_impression_url,
        }]
        console.warn({urlsWillReport})
        VideoBridgeReportUrls(urlsWillReport)
    }

    /**
     * 注册大模板页面元素用户交互事件监听
     * @param bigTemplateInstanceId 大模板实例 (父模板)
     * @returns {Promise<void>}
     */
    registerPageHandler() {

        // 注册二选一入口的点击事件
        window.mtg_fn_showVideoTemplateLegacy = async ({currentCampaignId = null}) => {

            if (currentCampaignId != null) {

                this.currentChildTpl = this.childTplList.filter(item => item.campaignId === currentCampaignId)[0]
                this.currentCampaign = this.campaignList.filter(item => item.id === this.currentChildTpl.campaignId)[0]

                // 如果可以获取父视图 "大模板" 的实例, 则开始 addSubView
                if (this.bigTemplateInstanceId) {
                    let addRes = await this.videoTemplateLegacy.append({
                        parentCmptId: this.bigTemplateInstanceId,
                        childCmptId: this.currentChildTpl.tplInstanceId
                    }).catch(err => {
                        console.warn({err})
                    })
                    console.log({addRes})
                } else {
                    console.warn('大模板实例获取失败', {bigTemplateInstanceId: this.bigTemplateInstanceId})
                }

            } else {
                console.warn('currentCampaignId 为空', {currentCampaignId})
            }
        }

    }

    /**
     * 检查是否所有模板都已经 preload 成功
     * @returns {boolean}
     */
    allTplPreloadFinished() {
        let isAllFinished = true
        for (let curTplItem of this.childTplList) {
            if (curTplItem.isPageLoadFinished === false) {
                isAllFinished = false
            }
        }
        return isAllFinished
    }

    /**
     * 初始化页面通用组件
     */
    initComponents() {

    }

    /**
     * 调用自定义 hybrid 指令, 请确保此方法仅在开发场景中使用
     * @param fnName
     * @param params
     * @returns {Promise<void>}
     */
    async customCommand({fnName, params}) {
        return await customCommand({fnName, params})
    }

    /**
     * 对 campaign 中需要展示的部分信息进行格式化, 以满足模板展示需求
     * @param campaignList
     * @returns {any}
     */
    formatCampaign(campaignList) {
        let campaignListTemp = JSON.parse(JSON.stringify(campaignList))
        campaignListTemp.forEach(item => {
            let rating = String(item.rating)
            item.rating = rating.indexOf('.') > -1 ? rating : (rating + '.0')
        })
        return campaignListTemp;
    }
}